export const updatePriceListAction = (state) => {
  return {
    type: "UPDATE_PRICE_LIST",
    payload: state,
  };
};
